// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationToast_toast__Z5ETk {
  position: fixed;
  top: 20px;
  right: 20px;
  background: white;
  position: fixed;
  top: auto;
  bottom: 20px;
  right: auto;
  left: 20px;
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: flex-start;
  gap: 12px;
  z-index: 9999;
  min-width: 300px;
  border-left: 4px solid #7a9e7e;
  transform: translateX(-120%);
  transition: transform 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}
.NotificationToast_toast--show__3Uppz {
  transform: translateX(0);
}
.NotificationToast_toast__content__B8fLu {
  flex: 1 1;
}
.NotificationToast_toast__icon__Mg60I {
  color: #7a9e7e;
}
.NotificationToast_toast__title__Q1EE2 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.NotificationToast_toast__body__-Qmta {
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}
.NotificationToast_toast__close__bkCvf {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  padding: 0;
}
.NotificationToast_toast__close__bkCvf:hover {
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/NotificationToast/NotificationToast.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EAEA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;EAEA,4BAAA;EACA,gEAAA;AADF;AAGE;EACE,wBAAA;AADJ;AAIE;EACE,SAAA;AAFJ;AAKE;EACE,cAAA;AAHJ;AAME;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAJJ;AAOE;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AALJ;AAQE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;AANJ;AAOI;EAAU,WAAA;AAJd","sourcesContent":[".toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: white;\n  position: fixed;\n  top: auto;      \n  bottom: 20px;\n  right: auto;\n  left: 20px;\n  \n  background: white;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  z-index: 9999;\n  min-width: 300px;\n  border-left: 4px solid #7a9e7e; \n\n  transform: translateX(-120%); \n  transition: transform 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n\n  &--show {\n    transform: translateX(0);\n  }\n\n  &__content {\n    flex: 1;\n  }\n\n  &__icon {\n    color: #7a9e7e;\n  }\n\n  &__title {\n    margin: 0 0 4px 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n  }\n\n  &__body {\n    margin: 0;\n    font-size: 13px;\n    color: #666;\n    line-height: 1.4;\n  }\n\n  &__close {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #999;\n    padding: 0;\n    &:hover { color: #333; }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast": `NotificationToast_toast__Z5ETk`,
	"toast--show": `NotificationToast_toast--show__3Uppz`,
	"toast__content": `NotificationToast_toast__content__B8fLu`,
	"toast__icon": `NotificationToast_toast__icon__Mg60I`,
	"toast__title": `NotificationToast_toast__title__Q1EE2`,
	"toast__body": `NotificationToast_toast__body__-Qmta`,
	"toast__close": `NotificationToast_toast__close__bkCvf`
};
export default ___CSS_LOADER_EXPORT___;
